/** Cible de navigation au clic sur une notification (cloche). */

export type NotificationLike = {
  metadata: Record<string, unknown> | null;
};



const stringMeta = (m: Record<string, unknown>, key: string): string | undefined => {
  const v = m[key];
  return typeof v === "string" && v.length > 0 ? v : undefined;
}



export const getClientNotificationPath = (notif: NotificationLike): string | null => {
  const m = notif.metadata;
  if (!m) return null;

  const actionUrl = stringMeta(m, "actionUrl");
  if (actionUrl && actionUrl.startsWith("/")) {
    return actionUrl;
  }

  const appointmentId = stringMeta(m, "appointmentId");
  if (appointmentId) {
    return `/appointments?appointmentId=${encodeURIComponent(appointmentId)}`;
  }

  if (stringMeta(m, "invoiceId")) {
    return "/payments";
  }

  if (stringMeta(m, "programAssignmentId")) {
    return "/programs";
  }

  if (stringMeta(m, "objectiveId")) {
    return "/objectives";
  }

  return null;
}
